module.exports = __webpack_public_path__ + "img/table_icon.6f0ae1b3.svg";